export enum ListingsAPIServingConfig {
  BROWSE_HIGH_COMMISSION = 'browse_high_commission',
  SEARCH_DYNAMIC_FACETS = 'search_dynamic_facets',
  SEARCH_HIGH_COMMISSION = 'search_high_commission',
}
